import { OptGroupData, OptionData, SearchOptions } from "select2";

var searchQuery = '';

export function globalMatcher(params: SearchOptions, data: OptionData | OptGroupData) {
    // If there are no search terms, return all results
    if (!params.term || params.term.trim() === '') {
        searchQuery = '';
        return data;
    }

    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined' || ['-1', '-2'].includes((data as any).id)) {
        return null;
    }

    // `params.term` should be a string
    // `data.text` is the text that is displayed to the user
    if (data.text.toLowerCase().includes(params.term.toLowerCase())) {
        searchQuery = params.term;
        return data;
    }

    // Return `null` if the term should not be displayed
    return null;
}

export function globalTemplateResult(result: OptionData) {
    if (result.id === '-1' || result.id === '') {
        return result.text;
    }
    if (searchQuery.trim() === '') return $(`<span>${result.text}</span>`);

    let finalText = result.text;
    finalText = finalText.replace(RegExp(searchQuery, 'gi'),(match, _args) => {
        return match.toLowerCase() === searchQuery.toLowerCase() ? `<b>${match}</b>` : match;
    });
    return $(`<span>${finalText}</span>`);
}

export function checkAndDestroySelect2(id: string) {
    if (id[0] !== '#') {
        id = '#' + id;
    }
    if ($(id).hasClass("select2-hidden-accessible")) {
        $(id).select2('destroy');
    }
}